import { CircularProgress } from "@mui/material";
import React from "react";
import "./BottomSaveButton.scss";

const BottomSaveButton = ({
  is_loading,
  cancle_button_name,
  save_button_name,
  button_hide,
  onCancel,
  submitButtonType = "submit",
  onSubmitClick = () => {},
}: {
  is_loading: boolean;
  cancle_button_name: string;
  save_button_name: string;
  submitButtonType?: string;
  button_hide: boolean;
  onCancel: any;
  onSubmitClick?: () => void;
}) => {
  return (
    <>
      {button_hide && (
        <div className="bottom-save-button-container">
          <button
            className="back-btn bottom-btn"
            onClick={onCancel}
            type="reset"
            disabled={is_loading ? true : false}
          >
            {cancle_button_name}
          </button>
          <button
            className="done-btn bottom-btn"
            disabled={is_loading ? true : false}
            type={submitButtonType as any}
            onClick={onSubmitClick}
          >
            {is_loading ? (
              <CircularProgress size={25} style={{ color: "white" }} />
            ) : (
              `${save_button_name}`
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default BottomSaveButton;
